import {Component, Input, Type} from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  @Input() title: string;
  @Input() icon: string;
  @Input() iconFont = false;
  @Input() component: Type<Component>;
}
